<template>
    <!--
        Le classi sono `c-callout` e `c-callout-{color}`, col prefisso: in CoreUI 3 la callout e uno dei
        componenti che lo porta (`scss/_callout.scss` definisce `.c-callout`), mentre card e alert no.
        Senza il prefisso il CSS non trova nulla e sparisce la barretta colorata a sinistra - il rilievo
        della PO sulla pagina Sync.
    -->
    <div class="c-callout" :class="`c-callout-${color}`"><slot /></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'CCallout',
    props: {
        color: { type: String, default: 'primary' },
    },
});
</script>
